import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/layout'
import ZhTW from '../components/Privacy/zhTW';

import styles from './privacy.module.scss';

class PrivacyPage extends Component {
  renderContent = () => {
    return <ZhTW />;
  };

  render() {
    return (
      <Layout mainStyle={styles.app}>
        {this.renderContent()}
      </Layout>
    )
  }
};

export default PrivacyPage;



// WEBPACK FOOTER //
// ./src/pages/privacy.js